export const passwordRule = {
  value: 8,
  message: 'Password must be at least 8 characters long',
}
export const emailRule = {
  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  message: 'This email address is not valid',
}
export const requiredRule = 'This field is required and cannot be empty'
export const passwordMustMatch = 'Password and repeat password must match'
